import { getPlatform } from "@shared/utils/get-platform";
import { AuthManager } from "./AuthManager";
import { IAuthManager } from "./interfaces/IAuthManager";
import { JwtClient } from "./strategies/JwtClient";
import { SessionClient } from "./strategies/SessionClient";

/**
 * Factory for creating authentication strategies.
 * Example usage:
 * const auth = AuthFactory.createAuth();
 * try {
 *   await auth.login(email, password);
 *   console.log("Logged in successfully");
 * } catch (error) {
 *   console.error(error);
 * }
 */
export class AuthFactory {
  /**
   * Creates an authentication strategy based on the current platform.
   * - WEB and DESKTOP use session/cookie auth (SessionClient)
   * - MOBILE uses JWT auth (JwtClient)
   * @returns An instance of the authentication strategy.
   */
  static createAuth(): IAuthManager {
    const platform = getPlatform();

    switch (platform) {
      case "WEB":
      case "DESKTOP":
        return this.createSessionAuth();
      default:
        return this.createJwtAuth();
    }
  }

  private static createSessionAuth(): IAuthManager {
    const auth = new AuthManager();
    auth.setClient(new SessionClient());
    return auth;
  }

  private static createJwtAuth(): IAuthManager {
    const auth = new AuthManager();
    auth.setClient(new JwtClient());
    return auth;
  }
}
